import { initialTotRaceState, ITotraceState } from '../state/totrace.state';
import { TotRaceActions, ETotRaceActions } from '../actions/totrace.actions';

export const totraceReducers = (
  state = initialTotRaceState,
  action: TotRaceActions
): ITotraceState => {
  switch (action.type) {
    case ETotRaceActions.GetTotRaceSuccess: {
      return {
        ...state,
        totrace: action.payload,
      };
    }
    case ETotRaceActions.GetTotReset: {
      return {
        ...state,
        totrace: null,
      };
    }

    default:
      return state;
  }
};
